var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3868_188466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3868_188466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6923 8.49999C21.1679 8.49999 21.5881 8.6824 21.9527 9.04724C22.3176 9.4119 22.5 9.83207 22.5 10.3077V11.923C22.5 12.028 22.4865 12.1405 22.4595 12.2605C22.4327 12.3803 22.4026 12.4922 22.3693 12.5962L19.5033 19.3587C19.3601 19.6786 19.1199 19.9487 18.7828 20.1692C18.4456 20.3897 18.0938 20.5 17.7273 20.5H7.2115V8.49999L13.0288 2.73274C13.2276 2.53407 13.4578 2.41549 13.7193 2.37699C13.9808 2.33849 14.2313 2.38332 14.471 2.51149C14.7108 2.63982 14.8865 2.8219 14.998 3.05774C15.1095 3.29357 15.1333 3.53782 15.0693 3.79049L13.9923 8.49999H20.6923ZM8.7115 9.13849V19H17.7308C17.8013 19 17.8733 18.9807 17.947 18.9422C18.0208 18.9037 18.077 18.8397 18.1155 18.75L21 12V10.3077C21 10.2179 20.9712 10.1442 20.9135 10.0865C20.8558 10.0288 20.7821 9.99999 20.6923 9.99999H12.0963L13.35 4.51924L8.7115 9.13849ZM4.30775 20.5C3.81058 20.5 3.385 20.323 3.031 19.969C2.677 19.615 2.5 19.1894 2.5 18.6922V10.3077C2.5 9.81057 2.677 9.38499 3.031 9.03099C3.385 8.67699 3.81058 8.49999 4.30775 8.49999H7.2115V9.99999H4.30775C4.21792 9.99999 4.14417 10.0288 4.0865 10.0865C4.02883 10.1442 4 10.2179 4 10.3077V18.6922C4 18.7821 4.02883 18.8558 4.0865 18.9135C4.14417 18.9712 4.21792 19 4.30775 19H7.2115V20.5H4.30775Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.e51ce5981040baafe96f3070af50ad6a.svg";
export { ForwardRef as ReactComponent };